/* @flow */
export const EXPANDED_GROUPS_EXPAND_GROUP = 'EXPANDED_GROUP/EXPAND_GROUP';

type ExpandedGroupsExpandGroupActionType = 'EXPANDED_GROUP/EXPAND_GROUP';

type ExpandedGroupsExpandGroupActionPayload = {
    index: number,
    hasModifiedMapViewport?: boolean
};

type ExpandedGroupsExpandGroupAction = {
    type: ExpandedGroupsExpandGroupActionType,
    payload: ExpandedGroupsExpandGroupActionPayload
};

export type Action = ExpandedGroupsExpandGroupAction;

const ACTION_CREATORS = {
    expandGroup({
        index,
        hasModifiedMapViewport
    }: ExpandedGroupsExpandGroupActionPayload): ExpandedGroupsExpandGroupAction {
        return {
            type: EXPANDED_GROUPS_EXPAND_GROUP,
            payload: {index, hasModifiedMapViewport}
        };
    }
};

export default {...ACTION_CREATORS};
